"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataFeedConfigT = exports.DataFeedConfig = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const device_data_mask_js_1 = require("../../solarxr-protocol/data-feed/device-data/device-data-mask.js");
const tracker_data_mask_js_1 = require("../../solarxr-protocol/data-feed/tracker/tracker-data-mask.js");
/**
 * All information related to the configuration of a data feed. This may be sent
 * as part of a `StartFeed`.
 */
class DataFeedConfig {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsDataFeedConfig(bb, obj) {
        return (obj || new DataFeedConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsDataFeedConfig(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new DataFeedConfig()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * Minimum delay in milliseconds between new data updates. This value will be
     * ignored when used for a `PollDataFeed`.
     */
    minimumTimeSinceLast() {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? this.bb.readUint16(this.bb_pos + offset) : 0;
    }
    dataMask(obj) {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? (obj || new device_data_mask_js_1.DeviceDataMask()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    syntheticTrackersMask(obj) {
        const offset = this.bb.__offset(this.bb_pos, 8);
        return offset ? (obj || new tracker_data_mask_js_1.TrackerDataMask()).__init(this.bb.__indirect(this.bb_pos + offset), this.bb) : null;
    }
    boneMask() {
        const offset = this.bb.__offset(this.bb_pos, 10);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    stayAlignedPoseMask() {
        const offset = this.bb.__offset(this.bb_pos, 12);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    serverGuardsMask() {
        const offset = this.bb.__offset(this.bb_pos, 14);
        return offset ? !!this.bb.readInt8(this.bb_pos + offset) : false;
    }
    static startDataFeedConfig(builder) {
        builder.startObject(6);
    }
    static addMinimumTimeSinceLast(builder, minimumTimeSinceLast) {
        builder.addFieldInt16(0, minimumTimeSinceLast, 0);
    }
    static addDataMask(builder, dataMaskOffset) {
        builder.addFieldOffset(1, dataMaskOffset, 0);
    }
    static addSyntheticTrackersMask(builder, syntheticTrackersMaskOffset) {
        builder.addFieldOffset(2, syntheticTrackersMaskOffset, 0);
    }
    static addBoneMask(builder, boneMask) {
        builder.addFieldInt8(3, +boneMask, +false);
    }
    static addStayAlignedPoseMask(builder, stayAlignedPoseMask) {
        builder.addFieldInt8(4, +stayAlignedPoseMask, +false);
    }
    static addServerGuardsMask(builder, serverGuardsMask) {
        builder.addFieldInt8(5, +serverGuardsMask, +false);
    }
    static endDataFeedConfig(builder) {
        const offset = builder.endObject();
        return offset;
    }
    unpack() {
        return new DataFeedConfigT(this.minimumTimeSinceLast(), (this.dataMask() !== null ? this.dataMask().unpack() : null), (this.syntheticTrackersMask() !== null ? this.syntheticTrackersMask().unpack() : null), this.boneMask(), this.stayAlignedPoseMask(), this.serverGuardsMask());
    }
    unpackTo(_o) {
        _o.minimumTimeSinceLast = this.minimumTimeSinceLast();
        _o.dataMask = (this.dataMask() !== null ? this.dataMask().unpack() : null);
        _o.syntheticTrackersMask = (this.syntheticTrackersMask() !== null ? this.syntheticTrackersMask().unpack() : null);
        _o.boneMask = this.boneMask();
        _o.stayAlignedPoseMask = this.stayAlignedPoseMask();
        _o.serverGuardsMask = this.serverGuardsMask();
    }
}
exports.DataFeedConfig = DataFeedConfig;
class DataFeedConfigT {
    constructor(minimumTimeSinceLast = 0, dataMask = null, syntheticTrackersMask = null, boneMask = false, stayAlignedPoseMask = false, serverGuardsMask = false) {
        this.minimumTimeSinceLast = minimumTimeSinceLast;
        this.dataMask = dataMask;
        this.syntheticTrackersMask = syntheticTrackersMask;
        this.boneMask = boneMask;
        this.stayAlignedPoseMask = stayAlignedPoseMask;
        this.serverGuardsMask = serverGuardsMask;
    }
    pack(builder) {
        const dataMask = (this.dataMask !== null ? this.dataMask.pack(builder) : 0);
        const syntheticTrackersMask = (this.syntheticTrackersMask !== null ? this.syntheticTrackersMask.pack(builder) : 0);
        DataFeedConfig.startDataFeedConfig(builder);
        DataFeedConfig.addMinimumTimeSinceLast(builder, this.minimumTimeSinceLast);
        DataFeedConfig.addDataMask(builder, dataMask);
        DataFeedConfig.addSyntheticTrackersMask(builder, syntheticTrackersMask);
        DataFeedConfig.addBoneMask(builder, this.boneMask);
        DataFeedConfig.addStayAlignedPoseMask(builder, this.stayAlignedPoseMask);
        DataFeedConfig.addServerGuardsMask(builder, this.serverGuardsMask);
        return DataFeedConfig.endDataFeedConfig(builder);
    }
}
exports.DataFeedConfigT = DataFeedConfigT;
